/* RC Helikopter Before / After — drag + keyboard slider */
(function () {
  'use strict';

  var INITIALIZED_FLAG = 'rcHeliBaReady';

  function initInstance(root) {
    if (!root || root.dataset[INITIALIZED_FLAG] === '1') return;

    var compare = root.querySelector('.rc-heli-ba__compare');
    var handle = root.querySelector('.rc-heli-ba__handle');
    if (!compare || !handle) return;

    var initial = parseFloat(compare.getAttribute('data-initial'));
    var position = isFinite(initial) ? initial : 50;
    var dragging = false;

    function clamp(n) {
      if (n < 0) return 0;
      if (n > 100) return 100;
      return n;
    }

    function setPosition(pct) {
      var v = clamp(pct);
      position = v;
      compare.style.setProperty('--rc-heli-ba-pos', v + '%');
      handle.setAttribute('aria-valuenow', String(Math.round(v)));
    }

    function pctFromEvent(e) {
      var rect = compare.getBoundingClientRect();
      if (rect.width === 0) return position;
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    function onPointerMove(e) {
      if (!dragging) return;
      setPosition(pctFromEvent(e));
    }

    function onPointerUp() {
      dragging = false;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
    }

    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      setPosition(pctFromEvent(e));
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('pointercancel', onPointerUp);
      try { handle.focus({ preventScroll: true }); } catch (err) { handle.focus(); }
      e.preventDefault();
    }

    function onKeyDown(e) {
      var delta = 0;
      switch (e.key) {
        case 'ArrowLeft':  delta = -1; break;
        case 'ArrowRight': delta = 1; break;
        case 'PageDown':   delta = -10; break;
        case 'PageUp':     delta = 10; break;
        case 'Home':       setPosition(0); e.preventDefault(); return;
        case 'End':        setPosition(100); e.preventDefault(); return;
        default: return;
      }
      e.preventDefault();
      setPosition(position + delta);
    }

    setPosition(position);
    compare.addEventListener('pointerdown', onPointerDown);
    handle.addEventListener('keydown', onKeyDown);

    root.dataset[INITIALIZED_FLAG] = '1';
  }

  function init() {
    var roots = document.querySelectorAll('.rc-heli-ba');
    for (var i = 0; i < roots.length; i++) {
      initInstance(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target;
    if (!target) return;
    var root = target.querySelector
      ? target.querySelector('.rc-heli-ba')
      : null;
    if (root) initInstance(root);
  });
})();
